import { createFileRoute } from "@tanstack/react-router";
import { CockpitModuleGate } from "@/components/cockpit/CockpitModuleGate";
import { CockpitPageHeader } from "@/components/cockpit/CockpitPageHeader";
import { CockpitPageShell } from "@/components/cockpit/CockpitPageShell";
import { WahlkalenderTable } from "@/components/cockpit/WahlkalenderTable";

/** Ticket WK6: nur die beobachteten Gemeinden – dieselbe Leseschicht. */
export const Route = createFileRoute("/_cockpit/cockpit/wahlkalender_/beobachtet")({
  head: () => ({
    meta: [
      { title: "Beobachtete Gemeinden – Wahlkalender – creategy" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <CockpitModuleGate module="wahlkalender">
      <CockpitPageShell>
        <CockpitPageHeader
          title="Beobachtete Gemeinden"
          description="Diese Gemeinden beobachtet Ihr Haus. Alle Personen Ihres Kontos sehen dieselbe Auswahl."
        />
        <WahlkalenderTable onlyWatched />
      </CockpitPageShell>
    </CockpitModuleGate>
  ),
});
